var render = function render(){
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "shadow rounded-lg"
  }, [_c('div', {
    staticClass: "flex justify-between items-center bg-gray-100 px-4 pt-2"
  }, [_c('div', {
    staticClass: "text-muted"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.selectedCount) + " " + _vm._s(_vm.selectedCount == 1 ? 'item' : 'items') + " selected "), _vm.rowsAreSelected ? _c('small', {
    staticClass: "pl-3"
  }, [_c('a', {
    staticClass: "link",
    staticStyle: {
      "border-radius": "2rem",
      "padding": "0.1rem 0.6rem"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.clearAllSelected.apply(null, arguments);
      }
    }
  }, [_vm._v("CLEAR")])]) : _vm._e()])]), _c('div', {
    staticClass: "text-right"
  }, [_c('YButton', {
    staticClass: "text-blue-600 hover:bg-blue-100",
    attrs: {
      "disabled": !_vm.rowsAreSelected
    },
    on: {
      "click": _vm.exportRows
    }
  }, [_vm._v(" Export Wizard ")]), _c('YButton', {
    staticClass: "text-red-600 hover:bg-red-100",
    attrs: {
      "disabled": true
    }
  }, [_vm._v(" Delete ")])], 1)]), _vm.data ? _c('YTable', {
    attrs: {
      "selectable": true,
      "selectBy": "id",
      "selected": _vm.selectedRowIds,
      "loading": _vm.isLoading,
      "data": _vm.data || []
    },
    on: {
      "update:selected": function ($event) {
        _vm.selectedRowIds = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "row",
      fn: function (props) {
        return [_c('td', [_c('campaign-info-cell', {
          key: `campaign-info-${props.rowData.id}`,
          attrs: {
            "row-data": props.rowData,
            "row-index": props.rowIndex
          }
        })], 1), _c('td', [_c('ul', _vm._l(props.rowData.advertisers, function (advertiser) {
          return _c('li', {
            key: advertiser.id
          }, [_c('router-link', {
            staticClass: "link",
            attrs: {
              "to": {
                name: 'Advertiser',
                params: {
                  id: advertiser.advertiserId
                }
              }
            }
          }, [_vm._v(" " + _vm._s(advertiser.name) + " ")])], 1);
        }), 0)]), _c('td', [_c('div', {
          staticClass: "w-24"
        }, [_c('expandable-countries-from-payouts', {
          key: `campaign-countries-${props.rowData.id}`,
          attrs: {
            "payouts": props.rowData.payouts,
            "show-count": 20
          }
        })], 1)]), _c('td', [_c('div', {
          staticClass: "flex flex-col 2xl:flex-row 2xl:justify-start gap-3 py-1"
        }, [_c('div', {
          staticClass: "w-auto 2xl:w-1/2"
        }, [_c('campaign-access-rules-cell', {
          key: `access-rules-${props.rowData.id}`,
          attrs: {
            "row-data": props.rowData,
            "row-index": props.rowIndex
          }
        })], 1), _c('div', {
          staticClass: "w-1/2"
        }, [_c('campaign-subscribers-cell', {
          key: `subscribers-${props.rowData.id}`,
          attrs: {
            "row-data": props.rowData,
            "row-index": props.rowIndex
          }
        })], 1)])]), _c('td', [_c('campaign-status-toggle-button', {
          key: `status-toggle-button-${props.rowData.id}`,
          attrs: {
            "campaign": props.rowData,
            "height": 30,
            "width": 80,
            "font-size": 11
          }
        })], 1), _c('td', {
          staticStyle: {
            "padding": "0"
          }
        }, [_c('admin-campaign-actions', {
          key: `campaign-actions-${props.rowData.id}`,
          attrs: {
            "campaign": props.rowData
          }
        })], 1)];
      }
    }], null, false, 902862224)
  }, [_c('template', {
    slot: "header-row"
  }, [_c('th'), _c('th', [_vm._v(" Advertisers ")]), _c('th', [_vm._v(" Countries ")]), _c('th', [_c('div', {
    staticClass: "flex flex-col 2xl:flex-row 2xl:justify-around text-left"
  }, [_c('div', {
    staticClass: "w-1/2"
  }, [_vm._v("Access Rule")]), _c('div', {
    staticClass: "w-1/2 mt-1 2xl:mt-0 2xl:pl-2"
  }, [_vm._v("Subscribers")])])]), _c('th', [_vm._v(" Status ")]), _c('th')])], 2) : _vm._e(), this.exportCampaignIds.length > 0 ? _c('campaign-export-tool', {
    attrs: {
      "campaigns": this.exportCampaignIds
    },
    on: {
      "close": function () {
        _this.exportCampaignIds = [];
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }